import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, common, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	drawerContent: {
		padding: spacing.md,
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		minHeight: '100%',
	},
	section: {
		backgroundColor: colors.background.light,
		border: common.border,
		borderRadius: common.borderRadius,
		padding: spacing.md,
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	sectionHeaderRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: spacing.sm,
	},
	sectionHeader: {
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
		color: colors.text.main,
	},
	sectionHeaderNoMargin: {
		marginBottom: 0,
	},
	sectionDescription: {
		fontSize: typography.fontSizes.xs,
		lineHeight: 1.5,
		color: colors.text.light,
		margin: 0,
	},
	sectionDescriptionNoMargin: {
		margin: 0,
	},
	sectionMeta: {
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.semibold,
		color: colors.text.light,
		backgroundColor: colors.hover.light,
		borderRadius: 12,
		padding: `2px ${spacing.sm}px`,
		whiteSpace: 'nowrap',
	},
	searchInputRow: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	searchInputWrapper: {
		flex: 1,
	},
	searchHint: {
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
		backgroundColor: colors.background.main,
		border: `1px dashed ${colors.border.main}`,
		borderRadius: 6,
		padding: spacing.sm,
		margin: 0,
	},
	contactOptions: {
		listStyle: 'none',
		margin: 0,
		padding: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	contactOptionRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: spacing.md,
		padding: spacing.sm,
		border: `1px solid ${colors.border.main}`,
		borderRadius: 8,
		backgroundColor: colors.background.light,
	},
	contactOptionInfo: {
		flex: 1,
		minWidth: 0,
	},
	contactOptionName: {
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.semibold,
		color: colors.text.main,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	contactOptionEmail: {
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	contactOptionSecondaryText: {
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
		fontStyle: 'italic',
	},
	emptyState: {
		textAlign: 'center',
		padding: spacing.md,
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		backgroundColor: colors.background.main,
		borderRadius: 8,
		margin: 0,
	},
	selectedContactsHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: spacing.sm,
	},
	selectedContactsList: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	contactLimit: {
		fontSize: typography.fontSizes.xs,
		color: colors.warning.dark,
		padding: spacing.sm,
		backgroundColor: colors.warning.light,
		border: `1px solid ${colors.warning.main}`,
		borderRadius: 6,
		textAlign: 'center',
	},
	progressIndicator: {
		marginTop: spacing.sm,
		padding: spacing.sm,
		backgroundColor: colors.background.main,
		borderRadius: 6,
	},
	progressLoading: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		marginTop: spacing.sm,
		padding: spacing.sm,
		backgroundColor: colors.background.main,
		borderRadius: 6,
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
	},
	progressStepItem: {
		marginBottom: spacing.xs,
	},
	progressStep: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		fontSize: typography.fontSizes.xs,
	},
	progressStepStatus: {
		paddingTop: 2,
		paddingBottom: 2,
		paddingLeft: 6,
		paddingRight: 6,
		borderRadius: 4,
		fontSize: typography.fontSizes.xxs,
		fontWeight: typography.fontWeights.bold,
		textTransform: 'uppercase',
	},
	progressStepName: {
		flex: 1,
		fontSize: typography.fontSizes.xs,
		color: colors.text.main,
	},
	promptReasoning: {
		// Indent past the status badge so the reasoning reads as belonging to the step above it.
		marginTop: spacing.xs,
		marginLeft: spacing.lg,
		padding: spacing.sm,
		borderLeft: `2px solid ${colors.border.main}`,
		backgroundColor: colors.background.light,
		borderRadius: 4,
	},
	promptReasoningLabel: {
		display: 'block',
		marginBottom: spacing.xs,
		fontSize: typography.fontSizes.xxs,
		fontWeight: typography.fontWeights.bold,
		textTransform: 'uppercase',
		color: colors.text.light,
	},
	promptReasoningText: {
		margin: 0,
		fontSize: typography.fontSizes.xs,
		color: colors.text.main,
		whiteSpace: 'pre-wrap',
	},
	progressStepDueDate: {
		fontSize: typography.fontSizes.xxs,
		color: colors.text.light,
	},
	statusQueued: {
		backgroundColor: colors.warning.light,
		color: colors.warning.dark,
	},
	statusSent: {
		backgroundColor: colors.hover.light,
		color: colors.primary.dark,
	},
	statusOpened: {
		backgroundColor: colors.success.light,
		color: colors.success.dark,
	},
	statusFailed: {
		backgroundColor: colors.danger.light,
		color: colors.danger.main,
	},
});
